app.ui.registerUi('customScroller', function(app) {
	var helpers = app.helpers.funcs;
	return {
		implementationExists: function() {
			return jQuery.fn.nanoScroller ? true : false;
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
		init: function($scope) {
			var $scrollElems = helpers.resolveScope('.nano, .chosen-results', $scope);
            if ( (!this.implementationExists()) || (!$scrollElems.length) ) return;
			$scrollElems.each(function(key, elem) {
				var theme = $(elem).data('scroll-theme');
				theme = theme ? theme : 'dark';
				var ops = {
					alwaysVisible: true
				};
				$(elem).nanoScroller(ops);
			});
		}
	};
});

